import { call, takeLeading, put } from 'redux-saga/effects'
import commonservices, { getExternalLocationInfo, LocationInfoResponseData } from '@common/services'
import { locationActions, LocationActionTypes } from '@common/state/location/actions'
import { LOCALES, CURRENCY } from '@common/constants'
import { getCountryFromCookie } from '@common/utils/cookie-utils'
import { AxiosResponse } from 'axios'
import { CurrencyRestrictionsResponseData, getCurrencyRestrictions } from '@buy/services'

export function* loadLocationInfo(action: ReturnType<typeof locationActions.getLocationInfo>) {
    try {
        const { isExternal } = action.payload
        const locationInfoResponse: AxiosResponse<LocationInfoResponseData> = isExternal
            ? yield call(getExternalLocationInfo)
            : yield call(commonservices.getLocationInfo)

        if (locationInfoResponse && locationInfoResponse.data) {
            const storedCountry = getCountryFromCookie()
            const { country, language } = locationInfoResponse.data

            // load currency restrictions for the country
            const currencyRestrictionsResponse: AxiosResponse<CurrencyRestrictionsResponseData> = yield call(
                getCurrencyRestrictions,
                country
            )
            const currencyRestrictions = currencyRestrictionsResponse.data
            const eligibleCurrency = Object.values(CURRENCY).includes(currencyRestrictions[0])

            // Call `getLocationInfo` call if the cookie stored country is not as same as the country got from the initial `getLocationInfo` call
            if (storedCountry && storedCountry !== country) {
                locationActions.getLocationInfo()
            } else {
                yield put(
                    locationActions.setLocationInfo({
                        country,
                        currency: eligibleCurrency ? currencyRestrictions[0] : currencyRestrictions[1],
                        locale: `${language}-${country}` as LOCALES,
                        language,
                    })
                )
                yield put(locationActions.setIsLocationInfoLoaded(true))
            }
        }
    } catch (e: any) {
        console.error(e.message)
    }
}

function* initializeLoadLocationInfoSaga() {
    yield takeLeading(LocationActionTypes.GET_LOCATION_INFO, loadLocationInfo)
}

export default initializeLoadLocationInfoSaga
